import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const GET_STATEMENT = gql`
  query GetStatement($year: Int!) {
    statement(statementRequest: { year: $year }) {
      dailyRateClient
      dailyRateConsultant
      daysSick
      daysWorked
      employeeContributions
      employerCost
      employerContributions
      expenses
      grossSalary
      companyBenefit
      netSalary
      overflow
      otherOperations
      otherOperationsCredit
      otherOperationsDebit
      initialization
      interestsPayment
      investments
      investmentsCredit
      investmentsDebit
      statementMonths {
        consultantServiceAmount
        cooptation
        currency
        dailyRateClient
        dailyRateConsultant
        daysSick
        daysWorked
        employeeContributions
        employerCost
        employerContributions
        employerCostExclBonus
        expenses
        grossSalary
        companyBenefit
        month
        netSalary
        overflow
        overflowBalance
        overflowDebit
        overflowCredit
        taxes
        uuid
        commission
        otherOperations
        otherOperationsCredit
        otherOperationsDebit
        initialization
        interestsPayment
        investments
        investmentsCredit
        investmentsDebit
        cooptations {
          amount
          cooptedName
          cooptedUuid
          currency
          percentage
          uuid
        }
      }
      taxes
      year
    }
  }
`;

const useStatement = (selectedYear, skip = false) => {

  const { data, loading, error, refetch } = useQuery(GET_STATEMENT, {
    skip: skip || !selectedYear,
    variables: { year: selectedYear },
  });

  return {
    data: data?.statement || null,
    loading,
    error,
    refetch,
  };
};

export default useStatement;
